import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";


function BookAppointment(){
  const navigate = useNavigate(); 
  useEffect(() => {
           const scriptUrls = [
             'assets/js/jquery.min.js',
             'assets/js/bootstrap.bundle.min.js',
             'assets/js/moment.min.js',
             'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
             'assets/vendor/overlay-scroll/custom-scrollbar.js',
             'assets/vendor/daterange/daterange.js',
             'assets/vendor/daterange/custom-daterange.js',
             'assets/vendor/jquery-ui/jquery-ui.min.js',
             'assets/vendor/jquery-ui/custom.js',
             'assets/vendor/datatables/dataTables.min.js',
             'assets/vendor/datatables/dataTables.bootstrap.min.js',
             'assets/vendor/datatables/custom/custom-datatables.js',
             'assets/js/custom.js'
           ];
       
           let isCancelled = false;
       
           // Load scripts sequentially
           const loadScriptsSequentially = async () => {
             for (const url of scriptUrls) {
               if (isCancelled) break;
       
               await new Promise((resolve, reject) => {
                 const script = document.createElement('script');
                 script.src = url;
                 script.onload = resolve;
                 script.onerror = reject;
                 document.body.appendChild(script);
               });
             }
           };
       
           loadScriptsSequentially();
       
           return () => {
             isCancelled = true;
             // Optionally remove scripts if needed
           };
         }, []);
  // const [isDropdownOpen, setDropdownOpen] = useState(false);
  // const location = useLocation();
  // const currentPath = location.pathname;

  // const appointmentPaths = [
  //   "/appointments",
  //   "/appointment-list",
  //   "/book-appointment",
  //   "/appointment-success",
  //   "/edit-appointment",
  // ];

  // // Automatically open dropdown if on any appointment route
  // useEffect(() => {
  //   if (appointmentPaths.includes(currentPath)) {
  //     setDropdownOpen(true);
  //   } else {
  //     setDropdownOpen(false);
  //   }
  // }, [currentPath]);
  const handleCancel = () => {
    navigate("/appointment-list");
    setTimeout(() => {
      window.location.reload(); // force page refresh after navigation
    }, 100); 
  };

  const handleSubmit = () => 
  {
    // Optional: Add form validation logic here
    navigate("/appointment-list");
    setTimeout(() => {
      window.location.reload(); // force page refresh after navigation
    }, 100); 
  };
    return ( 
      <div>
            {/* App hero header starts */}
            <div className="app-hero-header d-flex align-items-center">
              {/* Breadcrumb starts */}
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="index-2.html">
                    <i className="ri-home-3-line" />
                  </a>
                </li>
                <li className="breadcrumb-item">Appointments</li>
                <li className="breadcrumb-item text-primary" aria-current="page">
                  Book Appointment
                </li>
              </ol>
              {/* Breadcrumb ends */}
              {/* Sales stats starts */}
              <div className="ms-auto d-lg-flex d-none flex-row">
                <div className="input-group">
                  <span className="input-group-text bg-primary-lighten">
                    <i className="ri-calendar-2-line text-primary" />
                  </span>
                  <input type="text" id="abc" className="form-control custom-daterange" />
                </div>
              </div>
              {/* Sales stats ends */}
            </div>
            {/* App Hero header ends */}
            {/* App body starts */}
            <div className="app-body">
              {/* Row starts */}
              <div className="row gx-4">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Book Appointment</h5>
                    </div>
                    <div className="card-body">
                      {/* Row starts */}
                      <div className="row gx-4">
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a1">Patient Name</label>
                            <input type="text" className="form-control" id="a1" placeholder="Enter fullname" />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a2">Patient Email</label>
                            <input type="email" className="form-control" id="a2" placeholder="Enter email address" />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a3">Gender</label>
                            <select className="form-select" id="a3">
                              <option value={0}>Select</option>
                              <option value={1}>Male</option>
                              <option value={2}>Female</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a4">Age</label>
                            <input type="number" className="form-control" id="a4" placeholder="Enter age" />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a5">Patient Phone</label>
                            <input type="text" className="form-control" id="a5" placeholder="Enter phone number" />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a6">Select Date</label>
                            <input type="date" className="form-control" id="a6" placeholder="Select date" />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a7">Select Time</label>
                            <input type="time" className="form-control" id="a7" placeholder="Select time" />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a8">Speacilist Doctor</label>
                            <select className="form-select" id="a8">
                              <option value={0}>Select</option>
                              <option value={1}>Gynecologist</option>
                              <option value={2}>Psychiatrists</option>
                              <option value={3}>Surgeon</option>
                              <option value={4}>Urologist</option>
                              <option value={5}>Paediatrician</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a9">Problem</label>
                            <textarea className="form-control" id="a9" placeholder="Enter Problem" rows={3} defaultValue={""} />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="d-flex gap-2 justify-content-end">
                     <button
                              type="button"
                              className="btn btn-outline-primary my-4"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>

                            <button
                              type="button"
                              className="btn btn-primary my-4"
                              onClick={handleSubmit}
                            >
                              Book Appointment
                            </button> 
                          </div>
                        </div>
                      </div>
                      {/* Row ends */}
                    </div>
                  </div>
                </div>
              </div>
              {/* Row ends */}
            </div>
            {/* App body ends */}
      </div>
    )
}
export default BookAppointment;